import * as React from 'react';
import l10n from '../../util/l10n';
import CKEditorToolbar, { ToolbarItems } from '../../custom-components/ckeditor/CKEditorToolbar';

import LinearProgress from 'material-ui/LinearProgress';

import Warning from '../../components/Warning';

import { makeCancelable, CancelablePromise } from '../../util/cancelablePromise';

interface ModulWithCKEditor {
    getCKEditorPromise(): Promise<CKEditor>;
}

export interface CKEditorEditViewProps {
    module: ModulWithCKEditor;
    items: ToolbarItems;
}

interface CKEditorEditViewState {
    ckEditor: CKEditor;
    hasSanitizedScripts: boolean;
}

export class CKEditorEditView extends React.Component<CKEditorEditViewProps, CKEditorEditViewState> {

    private ckEditorPromise: CancelablePromise<CKEditor>;

    constructor(props: CKEditorEditViewProps) {
        super(props);
        this.state = {
            ckEditor: null,
            hasSanitizedScripts: false,
        };
        this.ckEditorPromise = makeCancelable(this.props.module.getCKEditorPromise());
        this.ckEditorPromise.then(ckEditor => {
            this.setState({ckEditor} as CKEditorEditViewState, () => {
                this.detectSanitizedScripts();
                ckEditor.on('change', this.onCkEditorChange);
                ckEditor.on('dataReady', this.onCkEditorChange);
            });
        });
    }

    componentWillUnmount() {
        const { ckEditor } = this.state;
        this.ckEditorPromise.cancel();
        if (ckEditor) {
            ckEditor.removeListener('change', this.onCkEditorChange);
            ckEditor.removeListener('dataReady', this.onCkEditorChange);
        }
    }

    render() {
        const { ckEditor, hasSanitizedScripts } = this.state;

        if (ckEditor) {
            return (
            <div>
                <CKEditorToolbar
                    ckEditor={this.state.ckEditor}
                    items={this.props.items}
                />
                {
                    hasSanitizedScripts ?
                        <Warning text={l10n("module.textHasSanitizedScripts")} isError={true} />
                        :
                        null
                }
            </div>
        );
        }
        return (
            <div>
                <LinearProgress mode="indeterminate" />
            </div>
        );
    }
    private onCkEditorChange = () => {
        this.detectSanitizedScripts();
    }

    private detectSanitizedScripts() {
        let hasSanitizedScripts = false;

        if (
            this.state.ckEditor
            && this.state.ckEditor.element
            && this.state.ckEditor.element.$
        ) {
            const editEl = this.state.ckEditor.element.$;
            hasSanitizedScripts =
                editEl.querySelectorAll('[data-sanitized]').length > 0
                // CKEditor protects script elements using comments (see core/htmldataprocessor.js::protectSource)
                || editEl.innerHTML.match(/<!--\{cke_protected\}[\s\S]*data-sanitized[\s\S]*-->/gi) !== null
                ;
        }

        if (hasSanitizedScripts !== this.state.hasSanitizedScripts) {
            this.setState({
                hasSanitizedScripts
            } as CKEditorEditViewState);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/CKEditorEditView.tsx
 **/